// Action types
export const ADD_BULK_OPERATION = 'ADD_BULK_OPERATION';
export const REMOVE_BULK_OPERATION = 'REMOVE_BULK_OPERATION';
export const UPDATE_BULK_OPERATION_PROGRESS = 'UPDATE_BULK_OPERATION_PROGRESS';
export const CLEAR_BULK_OPERATIONS = 'CLEAR_BULK_OPERATIONS';

/**
 * Add a new bulk operation to track
 * @param {Object} operation - Operation data
 * @param {string} operation.teamUuid - Team UUID
 * @param {string} operation.workflowFileId - Workflow file ID
 * @param {string} operation.workflowType - Workflow type ('cfdi', 'cancel')
 * @param {string} operation.operationLabel - Human readable label
 * @returns {Object} Redux action
 */
export const addBulkOperation = (operation) => {
  return {
    type: ADD_BULK_OPERATION,
    payload: {
      ...operation,
      id: Date.now(),
      createdAt: new Date().toISOString(),
      status: 'pending', // Iniciar como pending en lugar de idle
      processed: 0,
      errors: 0,
      pending: operation.total || 0 // Usar el total como pending inicial
    }
  };
};

/**
 * Remove a bulk operation from tracking
 * @param {string} workflowFileId - Workflow file ID to remove
 * @returns {Object} Redux action
 */
export const removeBulkOperation = (workflowFileId) => {
  return {
    type: REMOVE_BULK_OPERATION,
    payload: workflowFileId
  };
};

/**
 * Update progress data for a bulk operation
 * @param {string} workflowFileId - Workflow file ID
 * @param {Object} progressData - Progress data from Firebase
 * @param {number} progressData.total - Total records
 * @param {number} progressData.processed - Processed records
 * @param {number} progressData.errors - Error count
 * @param {string} progressData.status - Operation status
 * @param {Array} progressData.errorDetails - Error details array
 * @returns {Object} Redux action
 */
export const updateBulkOperationProgress = (workflowFileId, progressData) => {
  return {
    type: UPDATE_BULK_OPERATION_PROGRESS,
    payload: {
      workflowFileId,
      progressData: {
        ...progressData,
        lastUpdated: new Date().toISOString()
      }
    }
  };
};

/**
 * Clear all bulk operations
 * @returns {Object} Redux action
 */
export const clearBulkOperations = () => {
  return {
    type: CLEAR_BULK_OPERATIONS
  };
};



// WEBPACK FOOTER //
// ./src/redux/actions/bulkOperationsActions.js